
export function RLPager() {
    var directive: ng.IDirective = {
        restrict: "EA",
        template: require("/assets/app/templates/pagerElement.html"),
        scope: {
            page: "=",
            pageCount: "=",
            numFound: "=?",
            recordType: "@",
            rowCount: "=",
            onPageChanged: "&?",
            onPageSizeChanged: "&?"
        },
        bindToController: true,
        controller: RLPagerController,
        controllerAs: "pgrVM"
    };
    return directive;
}

interface IRLPageScope extends ng.IScope {
    page: number;
    pageCount: number;
    numFound: number;
    recordType: string;
    rowCount: number;
    onPageChanged: (event: { page: number }) => any;
    onPageSizeChanged: (event: { pageSize: number }) => any;
}

class RLPagerController {
    static $inject = ["$scope", "$element", "$attrs"];

    page: number;
    pageCount: number;
    numFound: number;
    recordType: any;
    rowCount: number;

    firstRowCount: number;

    startRecords: number;
    endRecords: number;

    showJumpTo: boolean;
    showRecordCount: boolean;
    jumpTo: number;
    recordsPerPage: number[];
    showRowCount: boolean;

    onPageChanged: (event: { page: number }) => any;
    onPageSizeChanged: (event: { pageSize: number }) => any;


    constructor(private $scope: IRLPageScope, private $element: ng.IAugmentedJQuery, private $attrs: ng.IAttributes) {
        this.showJumpTo = $attrs["showJumpTo"] == "true";
        this.showRowCount = $attrs["showRowCount"] == "true";
        this.recordsPerPage = [10, 25, 50, 100];
        this.firstRowCount = 10;

        $scope.$watch(() => this.numFound, (newValue: number, oldValue: number) => {
            if (newValue != null && newValue != oldValue) {
                this.showRecordCount = true;
            }
        });

        $scope.$watch(() => this.rowCount, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.pageCount = Math.ceil(this.numFound / this.rowCount);
            }
        });

        $scope.$watchCollection(() => [this.page, this.pageCount, this.numFound], (newValue: number[], oldValue: number[]) => {
            if (this.numFound) {

                if (!this.rowCount) {
                    this.rowCount = 25;
                }

                this.jumpTo = Math.min(newValue[0] + 10, newValue[1]);

                if (this.numFound > this.rowCount) {
                    //Update the page count
                    this.pageCount = Math.ceil(this.numFound / this.rowCount);

                    if ((this.page - 1) * this.rowCount > this.numFound) {
                        this.startRecords = this.numFound - ((this.page - 1) * this.rowCount);
                    } else {
                        this.startRecords = (this.page - 1) * this.rowCount + 1;
                    }

                    if (this.page * this.rowCount > this.numFound) {
                        this.endRecords = this.numFound;
                    } else {
                        this.endRecords = this.page * this.rowCount;
                    }
                } else {
                    this.startRecords = 1;
                    this.endRecords = this.numFound;
                }
            }
        });
    }

    // fired when paging forward
    NextClick($event: ng.IAngularEvent) {
        this.PageTo(this.page + 1);
        $event.preventDefault();
    }

    // fired when paging backward
    PrevClick($event: ng.IAngularEvent) {
        this.PageTo(this.page - 1);
        $event.preventDefault();
    }

    // fired when page to button clicked
    PageTo(page: any) {
        var intPage = _.parseInt(page);
        // if the page is valid
        if (intPage >= 1 && page <= this.pageCount) {
            this.page = intPage;		// set page
        } else {
            this.jumpTo = this.page;  // set to	current	page
        }
        if (this.onPageChanged != null) {
            this.onPageChanged({ page: this.page });
        }
    }

    JumpTo($event: ng.IAngularEvent, page: any) {
        $event.preventDefault();
        this.PageTo(page);
    }

    PageSizeChanged() {
        this.page = 1;
        if (this.onPageSizeChanged != null) {
            this.onPageSizeChanged({ pageSize: this.rowCount });
        }
    }
}
